<template>
    <div>
      <vue-headful
        title="Trayectoria"
        description="Se inició como un laboratorio pequeño ubicado en la calle Boccuzzi 411, Florencio Varela. Gracias al trabajo diario, los vecinos y profesio... ver más"
      />

      <div class="front front--page">
        <div v-parallax="0.1" v-parallax.centerX class="bg-parallax bg-parallax--trayectoria"></div>
        <div class="container">
          <h1 class="title title--big color--white">Trayectoria</h1>
          <div class="separator separator--white"></div>
        </div>
      </div>

      <div class="page-body">
        <div class="container">
            <h2 class="color--light-blue" style="line-height: 1.6">
              <b>La decisión que inició el camino.</b> <br>
              <div style="padding-top: 10px;">
                <img :src="require('../../assets/img/logo-varelab-inline.png')" alt="" style="vertical-align: baseline"> <b>tu laboratorio.</b>
              </div>

            </h2>
            <h2 class="color--light-blue">Se inició como un laboratorio pequeño ubicado en la calle Boccuzzi 411, Florencio Varela. Gracias al trabajo diario, los vecinos y profesionales médicos confiaron en la calidad de los servicios de Varelab, favoreciendo al crecimiento del laboratorio y a la necesidad de ampliarse ediliciamente.</h2>

            <div class="page-block">
              <p class="color--gray">En 2014 se inaugura el edificio Varelab en la Av. Tte. Gral. Juan D. Perón 1004, sede edificada con estándares internacionales específicos para la construcción de laboratorios de alta complejidad, respetando normas para el cuidado del medio ambiente.</p> <br>
              <p class="color--gray">Varelab posee equipamiento premium de última generación de las principales marcas de insumos de laboratorio. Nuestro laboratorio cuenta con personal altamente capacitado, entre los que se encuentran especialistas en pediatría y gerontología. A su vez todos nuestros profesionales reciben capacitaciones periódicas sobre los distintos avances de la ciencia.</p> <br>
              <p class="color--gray"><b>Varelab busca que ese camino que se inició por aquella decisión sea recorrido de tu mano, juntos.</b></p>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'trayectoria'
}
</script>
<!-- styling for the component -->
<style>

</style>


// WEBPACK FOOTER //
// src/components/Institucional/Trayectoria.vue